import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { metaChannelAvailabilityService as service } from '../api/meta-channel-availability.service';

export function useMetaAvailability() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.metaAvailability, queryFn: service.getGlobal });
  const save = useMutation({ mutationFn: (patch: Parameters<typeof service.setGlobal>[0]) => service.setGlobal(patch),
    onSuccess: (data) => client.setQueryData(queryKeys.metaAvailability, data) });
  return { query, save };
}

export function useMetaOverride(companyId: string) {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.metaOverride(companyId),
    queryFn: () => service.getTenantOverride(companyId), enabled: !!companyId });
  const save = useMutation({ mutationFn: (patch: Parameters<typeof service.setTenantOverride>[1]) => service.setTenantOverride(companyId, patch),
    onSuccess: (data) => client.setQueryData(queryKeys.metaOverride(companyId), data) });
  return { query, save };
}
